import LoggerMutationType from 'app/enums/LoggerMutationType'

export default function(input){

    switch(input){

        case LoggerMutationType.CREATED: return 'Aangemaakt';
        case LoggerMutationType.AVAILABLE: return 'Beschikbaar';
        case LoggerMutationType.DEPLOYED: return 'Ingezet';
        case LoggerMutationType.RETURNING: return 'Retour';
        case LoggerMutationType.REPAIR_PENDING: return 'Behoeft reparatie';
        case LoggerMutationType.REPAIR_ACTIVE: return 'In reparatie';
        case LoggerMutationType.WRITTEN_OF: return 'Afgeschreven';
        default: return '';
    }
}